<template>
  <div class="app flex-row align-items-center" id="form-complete-reg">
    <div style="width: 100%;height: 100vh;">
      <CRow class="justify-content-center" style="height: 100%;margin: auto 0!important;">
        <CCol id="content-left" md="8" sm="7"
              style="background:url('/static/img/brand/background.jpg'); background-size: cover; background-repeat: no-repeat">
        </CCol>
        <CCol id="content-right" md="4" sm="5" style="margin:auto;">
          <div class="container">
            <div>
              <!--Logo-->
            </div>
            <CCard no-body style="background: #ffffffba;border: none!important;">
              <CCardBody>
                <h3 style="text-align: center;">Hoàn tất đăng kí</h3>
                <CRow>
                  <CCol sm="12" md="12" xl="12">
                    <BaseInput :options="fullNameInput.options" :data="fullNameInput.data" class="input-wrapper"/>
                  </CCol>
                  <!--Email-->
                  <CCol sm="12" md="12" xl="12">
                    <BaseInput :options="emailInput.options" :data="emailInput.data" class="input-wrapper"/>
                  </CCol>
                  <!--UserName-->
                  <CCol sm="12" md="12" xl="12">
                    <BaseInput :options="userNameInput.options" :data="userNameInput.data" class="input-wrapper"/>
                  </CCol>
                  <!--Password-->
                  <CCol sm="12" md="12" xl="12">
                    <BaseInput :options="passWordInput.options" :data="passWordInput.data" class="input-wrapper"/>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol cols="12" style="margin-top: 15px!important;">
                    <button type="button" class="px-12 ripple btn-primary" @click="submit" id="register"
                             style="padding: 8px!important; height: 42px!important;border-radius: 2.5rem!important;
                              background: linear-gradient(to right, #6e50ff, #506bff, #0093ff)!important;
                              font-size: 1rem!important;font-weight: 400!important;text-transform: uppercase;">
                      Hoàn tất đăng kí&nbsp;
                      <div class="ripple-effect" hidden></div>
                    </button>
                  </CCol>
                </CRow>
                <div style="margin-top: 15px;text-align: center;">
                    <span style="cursor: pointer;font-weight: bold;color: #4f1bfc;"
                          @click="loginSubmit">Đăng nhập với tài khoản khác</span>
                </div>
                <div style="display: flex;justify-content: center;margin-bottom: 15px;">
                </div>
              </CCardBody>
            </CCard>
          </div>
        </CCol>
      </CRow>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
  import $ from "jquery";

  import BaseLoading from "../base/BaseFormLoading";
  import BaseInput from "../base/BaseInput";
  import {authLogin} from "@/security/index";

  export default {
    name: 'complete-reg',
    components: {BaseInput, BaseLoading},
    notifications: {
      showSuccessMsg: {
        type: 'success',
        title: 'Success',
      },
      showErrorMsg: {
        type: 'error',
        title: 'Errors',
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    created: function () {
      if (this.$helper.checkLogin()) {
        this.$router.push('/dashboard.html');
      }
    },
    mounted: function () {
      let that = this;
      setTimeout(function () {
        that.setUpRippleButton();
      }, 1000);
      if (this.$route.params.email != null || this.$route.params.name != null) {
        this.emailInput.data.model = this.$route.params.email;
        this.fullNameInput.data.model = this.$route.params.name;
      } else {
        this.$router.push('/');
      }
    },
    data: function () {
      let that = this;
      if (this.$route.params.email !== 'undefined' && this.$route.params.email !== null && this.$route.params.email !== '') {
        this.disabled = true;
      }
      return {
        disabled: false,
        loading: {value: false},
        fullNameInput: {
          options: {
            label: "Họ và tên",
            placeholder: "Họ và tên",
            type: "text"
          },
          data: {
            name: "fullName",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.fullNameInput.data.model;
                if (value === '') {
                  this.isValid = false;
                  this.errorMessage = 'Tên của bạn không để trống';
                } else {
                  this.isValid = true;
                  this.errorMessage = ''
                }
                return this.isValid;
              }
            }
          }
        },
        emailInput: {
          options: {
            label: "Email",
            placeholder: "Email",
            type: "text",
            disabled: that.disabled,
          },
          data: {
            name: "email",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.emailInput.data.model;
                let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Email không được để trống";
                } else if (email_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage = "Email không đúng định dạng";
                } else if (email_regex.test(value) == true) {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        userNameInput: {
          options: {
            label: "Tài khoản",
            placeholder: "Tài khoản",
            type: "text"
          },
          data: {
            name: "userName",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.userNameInput.data.model;
                let username_regex = /^([a-zA-Z0-9 !%&@#$^*?_~]){6,}$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên đăng nhập không được để trống";
                } else if (username_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage = "Tên đăng nhập ít nhất 6 kí tự và là chữ thường";
                } else if (username_regex.test(value) == true) {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        passWordInput: {
          options: {
            label: "Mật khẩu",
            placeholder: "Mật khẩu",
            type: "password"
          },
          data: {
            name: "password",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.passWordInput.data.model;
                let password_regex = /^(?=(?:[^A-Z]*[A-Z]){1,})(?=(?:[^a-z]*[a-z]){1,})(?=(?:[^0-9]*[0-9]){1,}).{8,}$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Mật khẩu không được để trống";
                } else if (password_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage = "Mật khẩu ít nhất 8 kí tự gồm chữ hoa, chữ thường, số";
                } else if (password_regex.test(value) == true) {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        idFbInput: {
          data: {
            name: "idUserFb",
            model: that.$route.params.idFb,
          }
        },
      }
    },
    methods: {
      submit: function () {
        let that = this;
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/user/registerAccountCustomer",
          dataRef: function () {
            return that.$data;
          },
          successCallback: function (response) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              that.showErrorMsg({
                message: that.$helper.getStringError(response.data.data)
              });
            } else {
              authLogin(
                dataResponse.data.access_token,
                dataResponse.data.Authorities,
                dataResponse.data.username
              );
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },

      setUpRippleButton: function () {
        $('.ripple').on('click', function (event) {
          event.preventDefault();
          var $div = $('<div/>'),
            btnOffset = $(this).offset(),
            xPos = event.pageX - btnOffset.left,
            yPos = event.pageY - btnOffset.top;
          $div.addClass('ripple-effect');
          var $ripple = $(".ripple-effect");
          $div.css({
            top: yPos - ($ripple.height() / 2),
            left: xPos - ($ripple.width() / 2),
          })
            .appendTo($(this));
          window.setTimeout(function () {
            $div.remove();
          }, 1500);
        });
      },
      loginSubmit: function () {
        this.$router.push('/').catch(e => {
        });
      }
    },
  }
</script>

<style>
  #form-complete-reg .input-wrapper > div > input {
    height: 42px !important;
  }
</style>
<style scoped>
  fieldset {
    border: 1px solid #ccc;
    padding: 15px;
    max-width: 345px;
    background-color: #fff;
    border-radius: 5px;
  }

  section {
    padding: 0 15px;
  }

  @media (max-width: 350px) {
    .container {
      padding: 0px !important;
    }

    #content-left {
      width: 0;
      height: 0;
    }
  }

  @media (min-width: 350px) and (max-width: 575px) {
    .container {
      padding: 0px !important;
    }

    #content-left {
      width: 0;
      height: 0;
    }
  }

  @media (min-width: 576px) and (max-width: 767px) {
    .container {
      padding: 0px !important;
    }

    #content-right {
      padding-left: 0px;
      padding-right: 0;
    }

  }
</style>

